import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import PaymentOptionsView from './PaymentOptionsView';
import { Creators as paymentBanksActions } from '../../../../../domain/useCases/payments/getPaymentBanks';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

const PaymentOptionsViewController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    data: paymentBanksResults,
    isLoading,
    isSuccess
  } = useSelector((state: any) => state.getPaymentBanks);
  const [payOptX, setPayOptX] = useState(false);

  const goBackButton = () => {
    GoogleAnalytics.writeLog('back-from-options', 'backbutton');
    history.push('/pagos');
  };

  const handlerRedirect = (route: string) => {
    GoogleAnalytics.writeLog(
      `GoTo-${route.replaceAll('pagos/', '')}`,
      'redirect',
      route
    );
    history.push(`/${route}`);
  };

  useEffect(() => {
    XCheckpointManager.registerStart('Opciones de pago');
    dispatch(paymentBanksActions.getPaymentBanks());
    setPayOptX(true);
  }, []);

  useEffect(() => {
    if (payOptX && paymentBanksResults && !isLoading && isSuccess) {
      XCheckpointManager.registerEnd('Opciones de pago');
      setPayOptX(false);
    }
  }, [payOptX, isLoading]);

  return (
    <PaymentOptionsView
      goBackButton={goBackButton}
      handlerRedirect={handlerRedirect}
      paymentBanksResults={paymentBanksResults}
    />
  );
};

export default PaymentOptionsViewController;
